<div #imageEdit (update)="newResult()"></div>